import{useRef as r,useLayoutEffect as t}from"react";function n(n){var e=r(void 0);return t((function(){e.current=n})),e.current}export{n as default};
//# sourceMappingURL=index.js.map
